import { useEffect, useState } from "react";

import { useMasterLookupsApi } from "../../../../../../../common/api/master-api/lookups/useMasterLookupsApi";
import { formOptionsLoader } from "../../../../../../../common/components/form/FormOptionsLoader";
import { AspectRatio } from "../../../../../../../common/data/lookup-data-providers/AspectRatiosDataProvider";
import { AspectType } from "../../../../../../../common/data/lookup-data-providers/AspectTypesDataProvider";

export const useCloudFileAssociationVideoTechnicalDetailsOptions = () => {
    const { getAspectRatios, getAspectTypes } = useMasterLookupsApi();

    /* aspect ratios */
    const [aspectRatios, setAspectRatios] = useState<AspectRatio[]>([]);
    const [areAspectRatiosLoading, setAreAspectRatiosLoading] = useState(true);
    const loadAspectRatioOpts = (): void =>
        formOptionsLoader(getAspectRatios, setAreAspectRatiosLoading, setAspectRatios);

    /* aspect types */
    const [aspectTypes, setAspectTypes] = useState<AspectType[]>([]);
    const [areAspectTypesLoading, setAreAspectTypesLoading] = useState(true);
    const loadAspectTypeOpts = (): void => formOptionsLoader(getAspectTypes, setAreAspectTypesLoading, setAspectTypes);

    useEffect(() => {
        loadAspectRatioOpts();
        loadAspectTypeOpts();
    }, []);

    return {
        aspectRatios,
        areAspectRatiosLoading,

        aspectTypes,
        areAspectTypesLoading
    };
};
